import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';

export const Title = styled.div`
  ${({ theme: { locale } }) => setTypography('heading3', locale)}
  grid-column: 2 / -2;

  margin-bottom: 56px;

  ${mediaDesktop(
    css`
      grid-column: 2 / 2;
      margin-bottom: 0;
    `
  )}
`;

export const Values = styled.div`
  grid-column: 2 / -2;

  ${mediaDesktop(
    css`
      grid-column: 7 / -4;
    `
  )}
`;

export const ValueCard = styled.div`
  margin-bottom: 56px;

  &:last-child {
    margin-bottom: 120px;
  }

  ${mediaDesktop(css`
    margin-bottom: 120px;

    &:last-child {
      margin-bottom: 240px;
    }
  `)}
`;

export const ValueTitle = styled.div`
  ${({ theme: { locale } }) => setTypography('heading4', locale)}
  margin-bottom: 16px;

  ${mediaDesktop(css`
    margin-bottom: 20px;
  `)}
`;

export const ValueContent = styled.div`
  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
`;
